import { Route, Switch } from 'react-router';

import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import StaticPageReloader from '../StaticPageReloader';
import AIAssistantHome from './AIAssistantHome';

// ==============================================================================

export default () => {
    return (
        <Switch>
            <Route exact={true} path={ToxnotReactComponentPaths.BaseAIAssistantHomePath} component={AIAssistantHome} />
            <Route component={StaticPageReloader} />
        </Switch>
    );
}